/**
 * 生产环境配置
 * RippleX 项目 - 生产环境配置文件
 * 对应后端: prod 环境 (端口 3021)
 */

const config = {
  // 环境标识
  env: 'prod',
  
  // // API基础URL - 对应后端 prod 环境
  apiBaseURL: 'http://ripplex.visioninsight.com.cn/api/v1',

  // WebSocket URL
  wsBaseURL: 'ws://ripplex.visioninsight.com.cn/api/v1/ws/connect',
  
  // 是否开启调试模式
  debug: false,
  
  // 是否显示详细日志
  verbose: false,
  
  // Mock接口是否启用
  mock: false,
  
  // 上传文件大小限制 (MB)
  maxUploadSize: 100,
  
  // 请求超时时间 (毫秒)
  requestTimeout: 60000,
  
  // 是否启用请求重试
  enableRetry: true,
  
  // 页面标题后缀
  titleSuffix: ' - RippleX',
  
  // 是否启用开发者工具
  enableDevTools: false,
  
  // 静态资源基础路径
  publicPath: '/',
  
  // 版本信息
  version: '1.2.2.1'
}

export default config

// 单独导出各个配置项，方便按需引入
export const {
  env,
  apiBaseURL,
  wsBaseURL,
  debug,
  verbose,
  mock,
  maxUploadSize,
  requestTimeout,
  enableRetry,
  titleSuffix,
  enableDevTools,
  publicPath,
  version
} = config
